const getPrizeNumber = (place: number | undefined | null) => {
  if (!place) return undefined;
  if (place < 4) return place;
  if (place < 6) return 4;
  return 5;
};

export const getBlastPrizeNumber = getPrizeNumber;
export const getBlastRefPrizeNumber = getPrizeNumber;

export const getCamelotRefPrizeNumber = getPrizeNumber;
export const getCamelotPrizeNumber = (place: number | undefined | null) => {
  if (!place) return undefined;
  if (place < 4) return place;
  if (place < 6) return 4;
  if (place < 11) return 5;
  if (place < 21) return 6;
  return 7;
};
